export default "__VITE_PUBLIC_ASSET__2e55b240__"